import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { Css, Responsive } from '@/ui';
import {
	BaseCell,
	BaseHeader,
} from '../../../../flights/overview/ui/list/columns/Column';
import { calculateTimeAgo } from '../../../domain/use-cases/calculateTimeAgo';

interface IPostedProps {
	time: string;
}

const styles = css`
	flex-grow: 1;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: none;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles}
	font-size: ${Css.pxToRem(14)};
	padding-right: ${Css.pxToRem(20)};
`;

export function Header() {
	return <StyledHeader>Posted</StyledHeader>;
}

export function Cell({ time }: IPostedProps) {
	return <StyledCell>{calculateTimeAgo(time)}</StyledCell>;
}
